/**
 * Format a fulfilment part as "N of M".
 * Missing or invalid values default to 1 so single-part orders render as "1 of 1".
 */
export const formatParts = (part, numberOfParts) => {
	const p = Number(part) > 0 ? Number(part) : 1;
	const n = Number(numberOfParts) > 0 ? Number(numberOfParts) : 1;
	return `${p} of ${n}`;
};

/** Path to order details by internal order_log ID. */
export const getOrderViewPath = (orderId) => {
	return `/order-view/${encodeURIComponent(orderId)}`;
};
